import socket from "../static/js/socket.js"
import UserActivity from "../static/js/user_activity.js"
import UserActivityCable from "../static/js/user_activity_cable.js"

const element = document.getElementById("user-activity")

// Транспорт выбирает сервер (feature flag): action_cable — встроенный ActionCable,
// иначе — легаси Phoenix-трекер. При reject подписки (rollback флага при уже
// отрендеренной странице) откатываемся на легаси-путь, чтобы не терять трекинг.
if (element && element.getAttribute("data-transport") === "action_cable") {
    UserActivityCable.init(element, () => UserActivity.init(socket, element))
} else {
    // data-state=legacy — маркер, что выбор транспорта отработал (см. data-state в user_activity_cable.js)
    if (element) { element.setAttribute("data-state", "legacy") }
    UserActivity.init(socket, element)
}
